import { render } from "./GroupSurveyParticipantsSection.vue?vue&type=template&id=47dfa390"
import script from "./GroupSurveyParticipantsSection.vue?vue&type=script&lang=js"
export * from "./GroupSurveyParticipantsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__